// extracted by mini-css-extract-plugin
export default {"LevelsSettings":"Settings_LevelsSettings__oaazR","AddNewLevel":"Settings_AddNewLevel__kbFk-","Icon":"Settings_Icon__Kgy1U","Loading":"Settings_Loading__FhkyX"};